import { FormControl, makeStyles, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import { React } from 'react'
import { useTranslate } from 'react-admin'
import SubscriptionAddonCard from '../SubscriptionAddonCard/SubscriptionAddonCard'
import mainSubscriptionTabStyles from './mainSubscriptionTab.styles'
import SUBSCRIPTION_STATES from '../../../utils/constants/subscriptionStates'
import useGetLocalStorage from '../../../hooks/useGetLocalStorage'
import localStorageIds from '../../../utils/constants/localStorageIds'
import orgIsInSubscriptionState from '../../../utils/helpers/orgIsInSubscriptionState'
import orgIsPayLocked from '../../../utils/helpers/orgIsPayLocked'
import BillingSummary from '../BillingSummary'
import ConditionalRender from '../../../components/ConditionalRender/ConditionalRender'
import COLORS from '../../../utils/constants/colors'
import hasNullRequiredValues from '../../../utils/constants/hasNullRequiredValues'
import ButtonWithLoader from '../../../components/ui/ButtonWithLoader/ButtonWithLoader'

const MainSubscriptionTab = ({
  handleActivateSubscription,
  isSubActivationLoading,
  subscriptionDetails,
  orgId,
  setTab,
}) => {
  const translate = useTranslate()
  const localStorageValue = useGetLocalStorage()
  const {
    [localStorageIds.SELECTED_ORG_SUB_STATUS]: selectedOrgSubscriptionStatus,
  } = localStorageValue || {}

  const useStyles = makeStyles(mainSubscriptionTabStyles)
  const classes = useStyles()

  const SUBSCRIPTION_PAGE_TEXT = {
    [SUBSCRIPTION_STATES.ACTIVE]: 'ra.text.orgSubscription',
    [SUBSCRIPTION_STATES.GRACE]: 'ra.text.orgSubscription',
    [SUBSCRIPTION_STATES.INACTIVE]: 'ra.text.activateOrgSubscription',
    [SUBSCRIPTION_STATES.PENDING]: 'ra.text.activateOrgSubscription',
  }
  const hasActivatedAddons = () => {
    return subscriptionDetails?.addons.some((addon) => addon.enabled)
  }

  return (
    <>
      <div className={classes.infoContent}>
        <ConditionalRender renderValue={hasActivatedAddons()}>
          <Typography variant='h5' gutterBottom className={classes.typographyBold}>
            {translate('ra.text.subscriptionSummary')}
          </Typography>
          <BillingSummary
            nextBillingDate={subscriptionDetails?.nextBillingDate}
            orgId={orgId}
            action={
              orgIsPayLocked() ? (
                <ButtonWithLoader
                  variant='contained'
                  onClick={() => {
                    if (hasNullRequiredValues(subscriptionDetails)) {
                      setTab(1)
                      return
                    }
                    handleActivateSubscription()
                  }}
                  label={translate('ra.buttons.subscribe')}
                  loading={isSubActivationLoading}
                  style={{
                    backgroundColor: COLORS.subscriptionBlue,
                    color: 'white',
                    textTransform: 'none',
                  }}
                />
              ) : null
            }
          />
        </ConditionalRender>

        <Typography
          variant='h5'
          className={classes.typographyBold}
          gutterBottom={
            !orgIsPayLocked() || !hasActivatedAddons()
          }
          style={{ marginTop: '45px' }}
        >
          {translate(SUBSCRIPTION_PAGE_TEXT[selectedOrgSubscriptionStatus])}
        </Typography>

        {orgIsPayLocked() && hasActivatedAddons() && (
          <Typography gutterBottom>{translate('ra.text.mainSubText')} </Typography>
        )}

        <FormControl className={classes.form}>
          {subscriptionDetails?.addons
            ?.slice()
            .sort((a, b) => {
              const order = { Livestream: 0, Studio: 1, Stats: 2, Fans: 3, Engage: 4 }
              return (order[a.id] ?? 99) - (order[b.id] ?? 99)
            })
            .map((addonItem) => (
            <div key={addonItem.id} style={{ width: '100%' }}>
              <SubscriptionAddonCard
                addon={addonItem}
                orgId={orgId}
                isCurrentAddon={orgIsInSubscriptionState([
                  SUBSCRIPTION_STATES.ACTIVE,
                  SUBSCRIPTION_STATES.GRACE,
                ])}
              />
            </div>
          ))}
        </FormControl>

      </div>
    </>
  )
}

MainSubscriptionTab.propTypes = {
  subscriptionDetails: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    nextBillingDate: PropTypes.string,
    vivaPaymentOrder: PropTypes.any,
    vivaPaymentOrderInitialTransactionId: PropTypes.any,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    streetNumber: PropTypes.string,
    zipCode: PropTypes.string,
    country: PropTypes.string,
    companyName: PropTypes.string,
    vatNumber: PropTypes.string,
    activity: PropTypes.string,
    needsInvoice: PropTypes.bool,
    addons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        pricing: PropTypes.string,
        enabled: PropTypes.bool,
      }),
    ),
    cardFourLastDigits: PropTypes.string,
    coupon: PropTypes.any,
  }),
  setTab: PropTypes.func,
  handleActivateSubscription: PropTypes.func,
  isSubActivationLoading: PropTypes.bool,
  orgId: PropTypes.string,
}

export default MainSubscriptionTab
